export const arrayMove = (arr: any[], oldIndex: number, newIndex: number) => {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
};

export const concatArrayOfStrings = (specialities: string[]) => {
  return specialities && specialities?.length > 0
    ? specialities.reduce((result, item) => result.concat(', ', item), '' as string).substring(2)
    : undefined;
};
export const getArrayOfStringsFromString = (value: string | undefined): string[] => {
  return value && value.length > 0 ? value.split(',').map((t) => t.trim()) : [];
};

export const isArrayOfStrings = (value: any): boolean => {
  return Array.isArray(value) && value?.length > 0 && value.every((item) => typeof item === 'string');
};

export const roundTwoDecimalsIfNeeded = (number: number | undefined | null) => {
  return number ? Math.round((number + Number.EPSILON) * 100) / 100 : 0;
};
